import React, { useEffect, useState } from "react";
import { surveyTQData } from "../../../../../utils/constants";
import { Button } from "primereact/button";

export default function SurveyTable() {
  const [openRowIndexes, setOpenRowIndexes] = useState([]);
  const [questions, setQuestions] = useState(null);

  useEffect(() => {
    const getQuestions = surveyTQData[0]?.responses.map((responseData) => {
      return responseData.question_title || "";
    });
    setQuestions(getQuestions);
  }, []);

  const toggleRow = (i) => {
    if (openRowIndexes.includes(i)) {
      const updatedRowIndexes = openRowIndexes.filter(
        (data, index) => data !== i,
      );
      setOpenRowIndexes(updatedRowIndexes);
    } else {
      setOpenRowIndexes([...openRowIndexes, i]);
    }
  };

  return (
    <div className="my-4">
      <div className="table-responsive">
        <table className="table survey-table">
          <thead className="table-light">
            <tr
              style={{
                borderBottom: "1px solid #999",
              }}
            >
              <th
                className="text-start"
                style={{
                  width: "70px",
                }}
              ></th>
              {questions?.map((question, i) => (
                <th
                  className="text-start"
                  style={{
                    width: "150px",
                    verticalAlign: "top",
                  }}
                  key={i}
                >
                  {i + 1}. {question}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {surveyTQData.map((row, index) => (
              <tr key={index}>
                <td
                  className="text-start"
                  style={{ verticalAlign: "top", position: "relative" }}
                >
                  {/* Expand button */}
                  <div
                    className="resCollapseBtnCont"
                    title="Click to Expand"
                    onClick={() => toggleRow(index)}
                  >
                    <i
                      style={{ fontSize: "12px" }}
                      className={
                        openRowIndexes.includes(index)
                          ? "pi pi-minus"
                          : "pi pi-plus"
                      }
                    ></i>
                  </div>
                  {row.user_id}
                </td>
                {row?.responses.map((data, i) => (
                  <td
                    className="text-start"
                    style={{ verticalAlign: "top" }}
                    key={i}
                  >
                    <div>
                      <strong>Transcript:</strong>
                    </div>
                    {data.transcript ? (
                      data.transcript.split(" ").length > 15 &&
                      !openRowIndexes.includes(index) ? (
                        <>
                          {data.transcript.split(" ").slice(0, 15).join(" ")}...{" "}
                          <Button
                            className="p-0"
                            link
                            onClick={(e) => {
                              e.preventDefault();
                              toggleRow(index);
                            }}
                          >
                            [+]
                          </Button>
                        </>
                      ) : (
                        <>
                          {data.transcript}{" "}
                          {data.transcript?.split(" ").length > 15 && (
                            <Button
                              className="p-0"
                              link
                              onClick={(e) => {
                                e.preventDefault();
                                toggleRow(index);
                              }}
                            >
                              [-]
                            </Button>
                          )}
                        </>
                      )
                    ) : null}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
